import { render, staticRenderFns } from "./CRMQuickLog.vue?vue&type=template&id=93566f2a&scoped=true&"
import script from "./CRMQuickLog.vue?vue&type=script&lang=js&"
export * from "./CRMQuickLog.vue?vue&type=script&lang=js&"
import style0 from "./CRMQuickLog.vue?vue&type=style&index=0&id=93566f2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93566f2a",
  null
  
)

export default component.exports